import { render, staticRenderFns } from "./ActButton.vue?vue&type=template&id=fa89273a&scoped=true&"
import script from "./ActButton.vue?vue&type=script&lang=ts&"
export * from "./ActButton.vue?vue&type=script&lang=ts&"
import style0 from "./act_button.scss?vue&type=style&index=0&id=fa89273a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa89273a",
  null
  
)

export default component.exports